// API Configuration for SyberKey Mobile App Simulator

// CPE builds: set REACT_APP_CPE_API_URL=https://cpe.syberkey.com (see deploy.sh)
const API_BASE_URL =
  process.env.REACT_APP_CPE_API_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  'https://api.syberkey.com';

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  ENDPOINTS: {
    LOGIN_USER: '/login/user',
    REGISTER_USER: '/v2/users',
    APPROVE: '/approve',
    KMS_GENERATE_KEY: '/kms/generate-data-key',
    REGISTRATION_ONBOARD: '/registration/onboard',
    LIVENESS_CONFIG: '/biometrics/liveness/config',
    LIVENESS_SESSION: '/biometrics/liveness/session',
    USER_TENANT_MAPPING: '/user-tenant-mapping',
    SESSIONS_STATUS: '/sessions/status'
  }
};

export const buildApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

export default API_CONFIG;
